import * as React from "react";
import { CheckBox } from "./CheckBox";

export const CheckBoxSet = ({ column, value, handleChange, disabled }) => {
	const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		let _value = value ?? [];

		if (event.target.checked) {
			_value = [...new Set([..._value, event.target.value])];
		} else {
			_value = value.filter((item) => item !== event.target.value);
		}

		handleChange(_value);
	};

	return (
		<div className="input-group-cr checkset">
			<div className="btn-group">
				{column?.options?.map((option) => (
					<CheckBox
						key={option.name}
						name={option.name}
						value={option.name}
						onChange={handleCheckbox}
						disabled={option.disabled || !!disabled}
						label={option?.label}
						checked={value?.includes(option.name) ?? false}
					/>
				))}
			</div>
		</div>
	);
};
